/** Hostname without port/path, e.g. `njis.example.com` or `localhost`. */
function hostnameFromUrl(url) {
	let domain = url;
	if (url.includes('://')) {
		domain = url.split('://')[1];
	}
	domain = domain.split('/')[0];
	return domain.split(':')[0];
}

/**
 * First label of the host (legacy helper).
 * `https://njis.example.com` → `njis`; `http://localhost:5173` → `localhost`
 */
export function getSubdomain(url) {
	const host = hostnameFromUrl(url);
	return host.split('.')[0];
}

/**
 * Short school / env label for login + document title.
 * localhost / loopback → `LOCAL`; `www` → null; else uppercased subdomain (`NJIS`, `PROED`, `VP`).
 */
export function siteLabelFromOrigin(url = typeof window !== 'undefined' ? window.origin : '') {
	if (!url) return null;
	const host = hostnameFromUrl(url);
	if (!host || /^www$/i.test(host)) return null;
	if (/^localhost$/i.test(host) || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) {
		return 'LOCAL';
	}
	const sub = host.split('.')[0];
	if (!sub || /^www$/i.test(sub)) return null;
	return sub.toUpperCase();
}
